const guiColors = {
    'motion-primary': 'hsla(20, 100%, 55%, 1)',
    'motion-primary-transparent': 'hsla(20, 100%, 55%, 0.9)',
    'motion-tertiary': 'hsla(20, 100%, 45%, 1)',

    'looks-secondary': 'hsla(20, 100%, 55%, 1)',
    'looks-transparent': 'hsla(20, 100%, 55%, 0.35)',
    'looks-light-transparent': 'hsla(20, 100%, 55%, 0.15)',
    'looks-secondary-dark': 'hsla(20, 100%, 45%, 1)',

    'extensions-primary': 'hsla(30, 85%, 55%, 1)',
    'extensions-tertiary': 'hsla(30, 85%, 30%, 1)',
    'extensions-transparent': 'hsla(30, 85%, 55%, 0.35)',
    'extensions-light': 'hsla(30, 57%, 75%, 1)',

    'drop-highlight': 'hsl(20, 100%, 68%)'
};

const blockColors = {
    checkboxActiveBackground: 'hsl(20, 100%, 55%)',
    checkboxActiveBorder: 'hsl(20, 100%, 45%)'
};

export {
    guiColors,
    blockColors
};